import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import BitcoinWalletTypesTable from './bwalletTypesTable';
import {
  getBitcoinWalletTypes,
  deleteBitcoinWalletType
} from '../services/bwalletTypeService';
import auth from '../services/authService';
import Spinner from './common/spinner';
import NotFound from './notFound';
import Alert from './common/alert';
import AddButton from './common/addButton';

class BitcoinWalletTypes extends Component {
  state = {
    bwtypes: [],
    loading: false
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const bwtypes_response = await getBitcoinWalletTypes();
    this.setState({ loading: false });
    const { data: bwtypes } = bwtypes_response.data;
    this.setState({ bwtypes });
  }

  handleDelete = async bwtype => {
    const originalBitcoinWalletTypes = this.state.bwtypes;
    const bwtypes = originalBitcoinWalletTypes.filter(
      bw => bw._id !== bwtype._id
    );
    this.setState({ bwtypes });

    try {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <Alert
              name="Bitcoin Wallet Type"
              onClose={() => {
                this.setState({ bwtypes: originalBitcoinWalletTypes });
                onClose();
              }}
              onDelete={async () => {
                await deleteBitcoinWalletType(bwtype._id);
                onClose();
              }}
            />
          );
        }
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast('This Bitcoin Wallet Type has already been deleted.');

      this.setState({ bwtypes: originalBitcoinWalletTypes });
    }
  };

  getPagedData = () => {
    const { bwtypes } = this.state;

    return { data: bwtypes };
  };

  render() {
    const { loading } = this.state;
    const { data: bwtypes } = this.getPagedData();
    const { isAdmin } = auth.getCurrentUser();
    if (loading) return <Spinner message="loading page data..." />;
    return isAdmin ? (
      <React.Fragment>
        <AddButton link="/bwallet-types/new" value="Add Bitcoin Wallet" />
        <BitcoinWalletTypesTable
          bwtypes={bwtypes}
          onDelete={this.handleDelete}
          message="Wallet Types"
        />
      </React.Fragment>
    ) : (
      <NotFound />
    );
  }
}

export default BitcoinWalletTypes;
